<div *ngIf="router.url == '/sikca-sorulan-sorular'" class="blog-top">
    <div class="container top-title">
    <div class="title">Sıkça Sorulan Sorular</div>
    <div class="b-title">
      <div class="slogan">Merak ettikleriniz burada!</div>
    </div>
   </div>

</div>
<div class="container">


  <div class="accordion">
    <div *ngFor="let question of questions; let i = index">
      <div class="accordion-item">
        <input type="radio" name="accordion" id="item{{i}}" class="accordion-checkbox" />
        <label for="item{{i}}" class="accordion-title" (click)="toggleAccordion(i)">
          <div class="Rectangle-11"><img src="../../../assets/images/arrow-right.svg"></div>
          <div class="Rectangle-12">{{ question.title }}</div>
        </label>
        <div class="accordion-content">
          <div [innerHTML]="question.content">

          </div>
        </div>
      </div>
    </div>
  </div>

</div>